var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15863_56266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5435 2.25605L13.7962 6.80398C13.8474 6.91942 13.928 7.01941 14.0299 7.09399C14.1319 7.16855 14.2516 7.21512 14.3771 7.22902L19.35 7.96576C19.4941 7.98426 19.6298 8.04336 19.7415 8.13614C19.8531 8.22892 19.9361 8.35155 19.9806 8.48971C20.0253 8.62787 20.0295 8.77587 19.9931 8.91641C19.9568 9.05695 19.8812 9.18422 19.7751 9.28339L16.1905 12.8396C16.0992 12.925 16.0304 13.032 15.9909 13.1508C15.9512 13.2696 15.942 13.3964 15.9639 13.5196L16.8281 18.5209C16.8532 18.6647 16.8373 18.8125 16.7825 18.9476C16.7277 19.0828 16.636 19.1998 16.5178 19.2855C16.3998 19.3711 16.26 19.4218 16.1145 19.432C15.969 19.4421 15.8234 19.4112 15.6947 19.3426L11.2176 16.9766C11.103 16.9203 10.977 16.8911 10.8492 16.8911C10.7215 16.8911 10.5955 16.9203 10.4809 16.9766L6.00378 19.3426C5.87498 19.4112 5.72954 19.4421 5.58402 19.432C5.4385 19.4218 5.29873 19.3711 5.18064 19.2855C5.06254 19.1998 4.97084 19.0828 4.91598 18.9476C4.86114 18.8125 4.84531 18.6647 4.87034 18.5209L5.73458 13.463C5.75649 13.3397 5.74722 13.2129 5.70764 13.0941C5.66805 12.9753 5.59938 12.8684 5.5079 12.7829L1.88089 9.28339C1.77358 9.18152 1.69812 9.0507 1.66364 8.90683C1.62916 8.76294 1.63715 8.61213 1.68663 8.47269C1.73611 8.33325 1.82496 8.21115 1.94242 8.12117C2.05988 8.0312 2.20091 7.97721 2.34843 7.96576L7.3214 7.22902C7.44693 7.21512 7.56662 7.16855 7.66855 7.09399C7.77047 7.01941 7.85106 6.91942 7.90229 6.80398L10.155 2.25605C10.2164 2.12359 10.3143 2.01145 10.4373 1.93285C10.5603 1.85426 10.7033 1.8125 10.8492 1.8125C10.9952 1.8125 11.1382 1.85426 11.2612 1.93285C11.3842 2.01145 11.4821 2.12359 11.5435 2.25605Z",
    stroke: "#AA1A5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15863_56266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.330078 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRate);
export default __webpack_public_path__ + "static/media/starRate.e59a36c8ed3f88dcc62e8d0a8c4a9fa1.svg";
export { ForwardRef as ReactComponent };